import { init } from './init';

export const NextRouterService = {
  init,
};
